import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  className?: string;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3.5 font-semibold rounded-lg transition-all duration-300 ease-in-out text-center';
  const variants = {
    primary: 'bg-nova-gold hover:bg-nova-gold-light text-nova-navy-dark shadow-[0_4px_14px_0_rgba(184,150,78,0.39)] hover:shadow-[0_6px_20px_rgba(184,150,78,0.23)] hover:-translate-y-0.5',
    outline: 'border-2 border-nova-gold text-nova-gold hover:bg-nova-gold hover:text-nova-navy-dark'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${className}`;
  if (href) {
    return <motion.a href={href} className={combinedClassName} whileTap={{
      scale: 0.98
    }} data-id="element-12">
        {children}
      </motion.a>;
  }
  return <motion.button className={combinedClassName} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-13">
      {children}
    </motion.button>;
}